"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beginPriceChange = beginPriceChange;
exports.priceChangedSuccess = priceChangedSuccess;
var _transform = _interopRequireDefault(require("lodash/transform"));
var _actionTypes = require("./actionTypes");
function beginPriceChange() {
  return {
    type: _actionTypes.PRICE_CHANGED_BEGIN
  };
}
// eslint-disable-next-line import/prefer-default-export
function priceChangedSuccess(choiceDeltas, asConfigured, strikeThroughPriceModel) {
  return {
    type: _actionTypes.PRICE_CHANGED_SUCCESS,
    // eslint-disable-next-line no-param-reassign
    choiceDeltas: (0, _transform["default"])(choiceDeltas, function (cds, delta) {
      return cds[delta.choiceId] = delta;
    }, {}),
    asConfigured: asConfigured,
    strikeThroughPriceModel: strikeThroughPriceModel
  };
}
//# sourceMappingURL=pricingActions.js.map